<template>
  <div class="sp-template">
    <div class="h-title">FBA地址</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
          <!-- <el-form-item label="国家" prop="country">
            <el-select filterable clearable v-model="conditions.countryCode" placeholder="请选择国家">
              <el-option v-for="item in countryCode" :key="item.id" :label="item.nameEn" :value="item.code"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-input v-model="conditions.search" placeholder="请输入关键字搜索"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-if="in_configs(70705)" type="primary" @click="query()">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(70701)" size="small" @click="addWarehouseAddress">添加FBA地址</el-button>
          <el-button v-if="in_configs(70702)" size="small" @click="upFormVisible = true">上传FBA地址</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" border stripe style="width: 100%">
        <el-table-column prop="warehouseCode" label="仓库编码"></el-table-column>
        <el-table-column prop="wholeAddress.countryCode" label="国家"></el-table-column>
        <el-table-column prop="wholeAddress.province" label="州/省"></el-table-column>
        <el-table-column prop="wholeAddress.city" label="城市"></el-table-column>
        <el-table-column prop="wholeAddress.address" label="仓库地址"></el-table-column>
        <el-table-column prop="wholeAddress.postCode" label="邮编"></el-table-column>
        <el-table-column prop="contactPerson" label="联系人"></el-table-column>
        <el-table-column prop="contactNumber" label="联系电话"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="enable" label="状态">
          <template slot-scope="scope">
            {{scope.row.enable ? '启用':'停用'}}
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建者"></el-table-column>
        <el-table-column prop="createAt" label="创建时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="in_configs(70703)" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="mini" v-if="in_configs(70704)" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="parseInt(total)">
      </el-pagination>
      <!-- 添加弹窗 -->
      <el-dialog :title="title" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="rulesForm('fbaForm')" width="500px" class="fullwidth-form__dialog">
        <el-form :model="fbaForm" :rules="rules" ref="fbaForm" size="small" label-width="80px">
          <el-form-item label="国家"  prop="countryCode">
            <el-select v-model.lazy="fbaForm.wholeAddress.countryCode" @change="getCountry" filterable>
              <el-option v-for="item in countryCode" :key="item.id" :label="item.nameEn" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="州/省"  prop="province">
            <el-select v-model.lazy="fbaForm.wholeAddress.province" @change="getProvince" filterable>
              <el-option v-for="item in province" :key="item.id" :label="item.nameEn" :value="item.nameEn"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市"  prop="city">
            <el-select v-model.lazy="fbaForm.wholeAddress.city" filterable>
              <el-option v-for="item in city" :key="item.id" :label="item.nameEn" :value="item.nameEn"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓库编码"  prop="warehouseCode">
            <el-input v-model="fbaForm.warehouseCode" auto-complete="off" placeholder="仓库编码"></el-input>
          </el-form-item>
          <el-form-item label="仓库地址"  prop="address">
            <el-input v-model.lazy="fbaForm.wholeAddress.address" placeholder="街道地址"></el-input>
          </el-form-item>
          <el-form-item label="联系人"  prop="contactPerson">
            <el-input v-model.lazy="fbaForm.contactPerson" placeholder="联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话"  prop="contactNumber">
            <el-input v-model.lazy="fbaForm.contactNumber" placeholder="联系电话"></el-input>
          </el-form-item>
          <el-form-item label="邮编"  prop="postCode">
            <el-input v-model.lazy="fbaForm.wholeAddress.postCode" placeholder="邮编"></el-input>
          </el-form-item>
          <el-form-item label="备注"  prop="remarks">
            <el-input v-model="fbaForm.remarks" auto-complete="off" placeholder="备注"></el-input>
          </el-form-item>
          <el-form-item label="状态" >
            <el-radio v-model="fbaForm.enable" label="true">启用</el-radio>
            <el-radio v-model="fbaForm.enable" label="false">停用</el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('fbaForm')">取 消</el-button>
          <el-button size="small" type="primary" @click="submitWareHouaseAddrForm('fbaForm')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 上传弹窗 -->
      <el-dialog title="上传FBA地址" :visible.sync="upFormVisible" width="500px">
        <el-form :model="upForm" size="small" label-width="80px">
          <el-form-item label="下载模板" >
            <a href="../../../../static/template/fba_address.xlsx" download="fba_address.xlsx" target="_blank">
              <el-button size="small" type="text">点击下载</el-button>
            </a>
          </el-form-item>
          <el-form-item label="上传文件" >
            <!-- 上传下载 -->
            <form action="FileUploadServlet" enctype="multipart/form-data" name="fileUploadForm" class="el-input--small">
              <input type="file" ref="fbaDocFile" id="fbaDocFile" style="display: none;" onchange="document.fileUploadForm.filePath.value = this.value" />
              <input type="button" class="el-button el-button--small" value="点击上传" onclick="document.fileUploadForm.fbaDocFile.click()" />
              <input type="text" class="el-input__inner" style="width:200px;" name="filePath" id="filePath" disabled />
            </form>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelFBA">取 消</el-button>
          <el-button size="small" type="primary" @click="uploadingFBA">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    var countryCodeCheck = (rule, value, callback) => {
      if (this.fbaForm.wholeAddress.countryCode == "") {
        callback(new Error("请选择国家"));
      } else {
        callback();
      }
    };
    var provinceCheck = (rule, value, callback) => {
      if (this.fbaForm.wholeAddress.province == "") {
        callback(new Error("请选择州或省"));
      } else {
        callback();
      }
    };
    var cityCheck = (rule, value, callback) => {
      if (this.fbaForm.wholeAddress.city == "") {
        callback(new Error("请选择城市"));
      } else {
        callback();
      }
    };
    var warehouseCodeCheck = (rule, value, callback) => {
      if (this.validate) {
        if (value == this.tableData.warehouseCode) {
          callback();
          return;
        }
      }
      this.$request1({
        method: 'GET',
        url: '/warehouse-address/validate',
        params: { warehouseCode: value }
      })
        .then(response => {
          console.log(response.data);
          if (response.data) {
            callback(new Error("仓库名称已存在"));
          } else {
            callback();
          }
        })
        .catch(error => {
          console.log(error);
        });
    };
    var addressCheck = (rule, value, callback) => {
      if (this.fbaForm.wholeAddress.address == "") {
        callback(new Error("请填写详细地址"));
      } else {
        callback();
      }
    };
    var postCodeCheck = (rule, value, callback) => {
      let ref = /^[0-9]{6}$/;
      if (this.fbaForm.wholeAddress.postCode == "") {
        callback(new Error("请填写邮政编码"));
      } else {
        callback();
      }
    };
    return {
      value3: true,
      validate: false,
      conditions: {
        countryCode: "",
        search: ""
      },
      title: "添加FBA地址",
      tableData: [],
      countryCode: [],
      province: [],
      city: [],
      fbaForm: {
        warehouseCode: "",
        wholeAddress: {
          countryCode: "",
          province: "",
          city: "",
          address: "",
          postCode: ""
        },
        contactNumber:"",
        contactPerson:"",
        remarks: "",
        enable: "true"
      },
      upForm: {
        test: "",
        radio: "1"
      },
      countrys: [
        {
          name: "区域一",
          value: "US"
        },
        {
          name: "区域二",
          value: "UN"
        }
      ],
      rules: {
        countryCode: [
          { required: true, validator: countryCodeCheck, trigger: "change" }
        ],
        province: [
          { required: true, validator: provinceCheck, trigger: "change" }
        ],
        city: [{ required: true, validator: cityCheck, trigger: "change" }],
        address: [{ required: true, validator: addressCheck, trigger: "blur" }],
        postCode: [
          { required: true, validator: postCodeCheck, trigger: "blur" }
        ],
        contactPerson: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" }
        ],
        contactNumber: [
          { required: true, message: "请输入联系人手机号码", trigger: "blur" },
        ],
        warehouseCode: [
          {
            required: true,
            message: "请输入仓库编码",
            trigger: "blur"
          },
          { validator: warehouseCodeCheck, trigger: "blur" }
        ],
        remarks: [
          {
            required: false
          }
        ]
      },
      currentPage: 1, //当前页
      pageSize: 10, // 每页显示条目个数
      total: 1, //总条数
      dialogFormVisible: false,
      upFormVisible: false,
      status: 0,
      error: "",
      formLabelWidth: "120px"
    };
  },
  components: {},
  created() {
    this.query();
    this.initCountry();
  },
  computed: {},
  methods: {
    //搜索
    query() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/warehouse-address',
        withCredentials: true,
        params: {
          countryCode: _this.conditions.countryCode,
          params: _this.conditions.search,
          currentPage: _this.currentPage,
          pageSize: _this.pageSize
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            let taskData = data.data;
            _this.total = data.total;
            if (_this.total > 0) {
              _this.tableData = taskData;
            } else {
              _this.tableData = [];
              _this.total = 0;
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取国家列表
    initCountry() {
      this.$request1({
        type: 'GET',
        url: '/country',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.countryCode = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 当选中国家后
    getCountry() {
      this.fbaForm.wholeAddress.province = "";
      this.fbaForm.wholeAddress.city = "";
      this.province = [];
      this.city = [];

      // 获取选择的国家id
      let countryId = "";
      let code = this.fbaForm.wholeAddress.countryCode;
      for (let i = 0; i < this.countryCode.length; i++) {
        if (this.countryCode[i].code == code) {
          countryId = this.countryCode[i].id;
        }
      }

      if (countryId == "") {
        return;
      }
      this.initProvince(countryId);
    },
    // 获取省份列表
    initProvince(countryId) {
      this.$request1({
        type: "GET",
        url: '/province/' + countryId + '',
        xhrFields: {
          withCredentials: true
        },
        params: {}
      })
        .then(response => {
          this.province = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 当选择州或省后
    getProvince() {
      this.fbaForm.wholeAddress.city = "";
      this.city = [];

      // 获取选择的州或省id
      let provinceId = "";
      let nameEn = this.fbaForm.wholeAddress.province;
      for (let i = 0; i < this.province.length; i++) {
        if (this.province[i].nameEn == nameEn) {
          provinceId = this.province[i].id;
        }
      }

      if (provinceId == "") {
        return;
      }

      // 获取城市列表
      this.$request1({
        type: "GET",
        url: '/city/' + provinceId + '',
        xhrFields: {
          withCredentials: true
        },
        params: {}
      })
        .then(response => {
          this.city = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //编辑
    handleEdit(index, row) {
      this.title = row ? "编辑FBA地址" : "添加FBA地址";
      this.dialogFormVisible = true;
      this.validate = true;
      this.initCountry();
      this.fbaForm.id = row.id;
      this.fbaForm.warehouseCode = row.warehouseCode;
      this.tableData.warehouseCode = row.warehouseCode;
      this.fbaForm.wholeAddress.countryCode = row.wholeAddress.countryCode;
      this.fbaForm.wholeAddress.province = row.wholeAddress.province;
      this.fbaForm.wholeAddress.city = row.wholeAddress.city;
      this.fbaForm.wholeAddress.address = row.wholeAddress.address;
      this.fbaForm.wholeAddress.postCode = row.wholeAddress.postCode;
      this.fbaForm.remarks = row.remarks;
      this.fbaForm.enable = row.enable.toString();
      this.status = 1;
      this.fbaForm.contactPerson = row.contactPerson;
      this.fbaForm.contactNumber = row.contactNumber;

      this.$request1({
        type: 'GET',
        url: '/country',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.countryCode = response.data.data;
          let countryId = "";
          let code = row.wholeAddress.countryCode;
          for (let i = 0; i < this.countryCode.length; i++) {
            if (this.countryCode[i].code == code) {
              countryId = this.countryCode[i].id;
            }
          }
          this.$request1({
            type: "GET",
            url: '/province/' + countryId + '',
            xhrFields: {
              withCredentials: true
            }
          })
            .then(response => {
              this.province = response.data.data;
              let provinceId = "";
              let nameEn = this.fbaForm.wholeAddress.province;
              for (let i = 0; i < this.province.length; i++) {
                if (this.province[i].nameEn == nameEn) {
                  provinceId = this.province[i].id;
                }
              }
              this.$request1({
                type: "GET",
                url: '/city/' + provinceId + '',
                xhrFields: {
                  withCredentials: true
                },
                params: {}
              })
                .then(response => {
                  this.city = response.data.data;
                })
                .catch(error => {
                  console.log(error);
                });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });
    },

    addWarehouseAddress() {
      this.title = "添加FBA地址";
      this.initCountry();
      this.dialogFormVisible = true;
      this.validate = false;
    },

    //添加地址
    submitWareHouaseAddrForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'post',
            url: '/warehouse-address',
            withCredentials: true,
            data: this.fbaForm
          })
            .then(response => {
              this.query();
              this.$refs[formName].resetFields();
              this.emptyForm();
              this.success();
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
          this.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancelFBA() {
      this.upFormVisible = false;
      var file = document.getElementById("fbaDocFile");
      file.outerHTML = file.outerHTML;
      file.value = ""; //虽然file的value不能设为有字符的值，但是可以设置为空值
      var fileText = document.getElementById("fbaDocFile");
      fileText.value = "";
    },
    uploadingFBA() {
      if (document.getElementById("fbaDocFile").files.length == 0) {
        this.$notify.info({
          title: "提示",
          message: "请选择文件"
        });
        return;
      }
      let formdata = new FormData();
      formdata.append(
        "fbaAddressFile",
        document.getElementById("fbaDocFile").files[0]
      );
      this.upFormVisible = false;
      let fileName = document.getElementById("fbaDocFile").files[0].name;
      fileName = fileName.substring(fileName.indexOf("."));

      if (fileName != ".xlsx" && fileName != ".xls") {
        this.$notify.info({
          title: "提示",
          message: "请选择EXCEL文件"
        });
        return;
      }
      this.$request1({
        method: 'POST',
        url: '/warehouse-address/uploading',
        data: formdata,
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            setTimeout(() => {
              this.query();
            }, 1500);
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
          var file = document.getElementById("fbaDocFile");
          file.outerHTML = file.outerHTML;
          file.value = ""; //虽然file的value不能设为有字符的值，但是可以设置为空值
          var fileText = document.getElementById("fbaDocFile");
          fileText.value = "";
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error
          });
        });
    },
    //删除
    handleDelete(index, row) {
      let self = this;
      this.$confirm("此操作将永久删除该FBA地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(_ => {
          this.$request1({
            method: 'post',
            url: '/warehouse-address/delete',
            withCredentials: true,
            params: {
              id: row.id
            }
          })
            .then(response => {
              self.tableData.splice(index, 1);
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除"
              });
            });
        })
        .catch(_ => {});
    },

    //修改状态
    changeStatus(index, row) {
      this.$request1({
        method: 'POST',
        url: '/warehouse-address/status',
        params: {
          id: row.id,
          enable: row.enable
        }
      })
        .then(response => {
          this.currentPage,
            this.pageSize,
            this.query(),
            this.$message({
              message: "修改成功",
              type: "success",
              center: true,
              duration: 1500
            });
        })
        .catch(error => {
          console.log(error);
          this.$message.error("操作失败");
        });
    },

    // 操作成功
    success() {
      if (this.status == 1) {
        this.$message({
          message: "修改成功",
          type: "success",
          center: true,
          duration: 1500
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          center: true,
          duration: 1500
        });
      }
    },

    //清空表单
    emptyForm() {
      this.fbaForm.id = "";
      this.fbaForm.warehouseCode = "";
      this.fbaForm.wholeAddress.countryCode = "";
      this.fbaForm.wholeAddress.province = "";
      this.fbaForm.wholeAddress.city = "";
      this.fbaForm.wholeAddress.address = "";
      this.fbaForm.wholeAddress.postCode = "";
      this.fbaForm.contactNumber="",
      this.fbaForm.contactPerson="",
      this.fbaForm.remarks = "";
      this.countryCode = "";
      this.province = "";
      this.city = "";
      this.fbaForm.enable = "true";
      this.dialogFormVisible = false;
    },
    //清空验证
    close(formRule) {
      this.$refs[formRule].resetFields();
      this.emptyForm();
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    //状态转换，1：启用，0：停用
    formatenable: function(row, colum, enable) {
      if (enable == "true") {
        return "启用";
      } else if (enable == "false") {
        return "停用";
      }
    },
    //分页
    handleSizeChange(val) {
      //pageSzie：每页条数
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      //currentPage：当前页
      this.currentPage = val;
      this.query();
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/fbaaddress.vue